import React from 'react';

const UserManage = () => {
    return (
        <div>
            <h1>UserManage</h1>
        </div>
    );
};

export default UserManage;